import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import {
	AccessStatus,
	ConfluenceEdition,
} from '@confluence/session-data/entry-points/SiteInformationQuery';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ConfluenceFreePoolTargetExperimentQuery } from './ConfluenceFreePoolTargetExperimentQuery';

export function preloadUpgradeModalQuery() {
	const { accessStatus, activationId, cloudId, edition, isLoggedIn, userId } =
		getPreloaderFnContext();
	const queries: Promise<any>[] = [];

	// Add preloading on SSR only if user is on Confluence Free
	if (
		isLoggedIn &&
		Boolean(activationId) &&
		Boolean(userId) &&
		Boolean(cloudId) &&
		edition === ConfluenceEdition.FREE &&
		(accessStatus == AccessStatus.LICENSED_USE_ACCESS ||
			accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS)
	) {
		queries.push(
			queryAgg({
				query: ConfluenceFreePoolTargetExperimentQuery,
				variables: {
					cloudId,
					productKey: 'confluence.ondemand',
				},
			}),
		);
	}

	return waitForAllReturnWhenError(queries);
}
